@if (isAway()) {
  <div appHorizontalTimeSlot class="unavailable"
    [gridStart]="hours()[0]"
    [startTime]="getAbsenceStartTime()"
    [endTime]="getAbsenceEndTime()"
    [cellWidth]="cellWidth()">
    <div class="unavailable-text">
      {{ showAsHoliday() ? 'Holiday' : 'Day Off' }}
    </div>
  </div>
}
